


const GridHeader = () => {

	return (
		<>
			<div className="app-grid-header">
				SKU
			</div>

			<div className="app-grid-header">
				Název
			</div>

			<div className="app-grid-header">
				OBJ/POTVR/DOR (ks)
			</div>

			<div className="app-grid-header">
				OBJ/POTVR/DOR (hl)
			</div>
		</>
	)
}

export default GridHeader;